import { useContext } from "react";
import AppContext from "../../Context/AppContext";
import {
  EXCELICON,
  EXECUTEICON,
  EXITICON,
  PDFICON,
  RESETICON,
} from "../../Utils/icons";

export default function ToolBar(props) {
  const { setActiveTab } = useContext(AppContext);
  const ExitHandler = () => {
    setActiveTab("");
  };
  const PDFHandler = (e) => {
    if (e.detail === 1) {
      if (props.PDFHandler) props.PDFHandler();
    }
  };
  const ExcelHandler = (e) => {
    if (e.detail === 1) {
      if (props.ExcelHandler) props.ExcelHandler();
    }
  };
  const ResetHandler = (e) => {
    if (e.detail === 1) {
      if (props.ResetHandler) props.ResetHandler();
    }
  };
  const ExecuteHandler = (e) => {
    if (e.detail === 1) {
      if (props.ExecuteHandler) props.ExecuteHandler();
    }
  };
  return (
    <div className="toolbar-wrap">
      <div className="title">{props.title}</div>
    {props.button !== true && (  
      <div className="icon-wrap">
        <i onClick={(e) => ResetHandler(e)}>
          <RESETICON />
        </i>
        <i onClick={(e) => ExecuteHandler(e)}>
          <EXECUTEICON />
        </i>
        {props.isShowPdf ? (
          <i onClick={(e) => PDFHandler(e)}>
            <PDFICON />
          </i>
        ) : null}

        {props.isShowExcel ? (
          <i onClick={(e) => ExcelHandler(e)}>
            <EXCELICON />
          </i>
        ) : null}

        <i onClick={(e) => ExitHandler(e)}>
          <EXITICON />
        </i>
      </div>
      )}
    </div>
  );
}
